import apiClient from '../lib/apiClient';

const designationsService = {
  // Get all designations
  getDesignations: async (filters = {}) => {
    try {
      const result = await apiClient.get('/designations', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch designations' };
    }
  },

  // Get designation by ID
  getDesignation: async (id) => {
    try {
      const result = await apiClient.get(`/designations/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch designation' };
    }
  },

  // Create designation
  createDesignation: async (data) => {
    try {
      const result = await apiClient.post('/designations', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create designation' };
    }
  },

  // Update designation
  updateDesignation: async (id, data) => {
    try {
      const result = await apiClient.put(`/designations/${id}`, data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update designation' };
    }
  },

  // Delete designation
  deleteDesignation: async (id) => {
    try {
      const result = await apiClient.delete(`/designations/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete designation' };
    }
  }
};

export default designationsService;

